<template>
  
	<a-collapse>
	    <a-collapse-panel key="1" :header="ccname">
	      <a-transfer class="tranbtn" :data-source="mockData" show-search :show-select-all="false" :list-style="{
	        width: '48%',
	        height: '300px',
	      }"
	      :titles="['候选抄送人', '已选抄送人']"
	       :operations="['选择', '移除']" :target-keys="targetKeys" :render="(item) =>`${item.deptName}-${item.userName}`"
	       @change="handleChange">
	      	<span slot="notFoundContent"> 没数据 </span>
			 
	      </a-transfer>
	    </a-collapse-panel>
	  </a-collapse>
	
</template>
<script>
	import { defineComponent, ref, watch } from 'vue';
	import {
		getDeptListEnable3,
		nacos_cc
	} from '@/api/system.js'
	export default {
		data() {
			return {
				ccname:'请选择抄送人',
				mockData: [],
				targetKeys: [],
				defaultcc: [],
				selected: []
			}
		},
		props: {
		   carbon: Number,
			data: {
				type: String,
				default: true,
			},
			money: {
				type: String,
				default: true,
			},
		},
		watch: {
				carbon(e) {
					console.log(e, 'eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee')
					if(e == 1) {
						// this.targetKeys = []
						// this.activeKey = []
						// this.$refs.collapseRef.selectedKeys([])
						

						this.ccname = '请选择抄送人'
						this.targetKeys = []
						this.$emit('targetKeys', [])

					} else {
				this.targetKeys = []
				this.defaultcc = []
				nacos_cc({
					type: 'seal'
				}).then((res) => {
					res.data.forEach((item) => {

						this.defaultcc.push(item.userId)
					})
					const mockData = []
					getDeptListEnable3().then((res) => {
						res.rows.forEach((item) => {
							const data = {
								key: item.userId,
								companyName: item.companyName,
								deptName: item.deptName,
								userName: item.userName,
								disabled: this.defaultcc.indexOf(item.userId) > -1,
							}
							mockData.push(data)
						})
						this.$emit('targetKeys', this.defaultcc)
						this.changeccname(this.defaultcc)
						console.log(this.defaultcc, 'this.defaultcc=======================')
					})
					this.mockData = mockData
				})
				this.targetKeys = this.defaultcc
				
					}
					// else {
						// this.targetKeys = []
						// this.$emit('targetKeys', [])
						// this.getMock()
					// }
				console.log(e,'eeeeeeeeeeeeeeeeeeeee==================')
				console.log(e,this.targetKeys, '==================')
			},
			data(val, old) {
				console.log(val, old)
			},
			money(val, old) {
				console.log(val, 'val========================')
				if(val>5000&&this.$store.getters.userInfo.companyId==168){
					this.defaultcc.push(566)
				}else{
					for(let i = 0;i<this.defaultcc.length;i++){
						if(this.defaultcc[i]==566){
							this.defaultcc.splice(i,1)
							break
						}
					}
				}
			},
		},
		created() {
		},
		mounted() {
			this.getMock()
		},
		methods: {
		    init(data) {
			this.$nextTick(() => {
					console.log(data, 'data======================')
				this.defaultcc = data
				const mockData = []
					getDeptListEnable3().then((res) => {
						res.rows.forEach((item) => {
							const data = {
								key: item.userId,
								companyName: item.companyName,
								deptName: item.deptName,
								userName: item.userName,
								disabled: this.defaultcc.indexOf(item.userId) > -1,
							}
							mockData.push(data)
						})
						// this.$emit('targetKeys', this.defaultcc)
						console.log(this.defaultcc, 'this.defaultcc=======================')
						this.changeccname(this.defaultcc)
						console.log(this.defaultcc, 'this.defaultcc=======================')
					})
					this.mockData = mockData
					this.targetKeys = this.defaultcc
			})
			},
			getMock() {
				const targetKeys = []
				nacos_cc({
					type: this.data,
				}).then((res) => {
					res.data.forEach((item) => {
						this.defaultcc.push(item.userId)
					})
					console.log(this.defaultcc, 'this.defaultcc===================')
					const mockData = []
					getDeptListEnable3().then((res) => {
						res.rows.forEach((item) => {
							const data = {
								key: item.userId,
								companyName: item.companyName,
								deptName: item.deptName,
								userName: item.userName,
								disabled: this.defaultcc.indexOf(item.userId) > -1,
							}
							mockData.push(data)
						})
						this.$emit('targetKeys', this.defaultcc)
						this.changeccname(this.defaultcc)
						console.log(this.defaultcc, 'this.defaultcc=======================')
					})
					this.mockData = mockData
				})
				this.targetKeys = this.defaultcc
			},
			handleChange(targetKeys, direction, moveKeys) {
				this.targetKeys = targetKeys
				this.$emit('targetKeys', targetKeys)
				this.changeccname(targetKeys)
			},
			changeccname(cc){
				getDeptListEnable3().then((res) => {
					var lis=[]
					res.rows.forEach(item=>{
						cc.forEach(itm=>{
							if(item.userId==itm){
								lis.push(item.userName)
							}
						})
					})
					if(lis.length){
						this.ccname=lis.join('、')
					}else{
						this.ccname='请选择抄送人'
					}
					
				})
			}
		},
	}
</script>
<style lang='less' scoped>
	.tranbtn {
		display: flex !important;
		justify-content: space-around !important;
		align-items: center !important;
	}

	::v-deep .ant-transfer-operation {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
	}

	::v-deep .ant-btn+.ant-btn {
		margin: 0 !important
	}
</style>
